import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-fluid p-grid" }
const _hoisted_2 = { class: "p-col" }
const _hoisted_3 = { class: "p-float-label p-field kn-flex" }
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = { class: "p-fluid p-grid" }
const _hoisted_6 = { class: "p-col-4" }
const _hoisted_7 = { class: "p-float-label p-text-uppercase p-m-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-solid fa-bars" })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "p-ml-2"
}
const _hoisted_10 = {
  key: 1,
  class: "p-ml-2"
}
const _hoisted_11 = { class: "p-col-4" }
const _hoisted_12 = { class: "p-float-label p-m-2" }
const _hoisted_13 = {
  for: "category",
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "p-float-label p-text-uppercase p-m-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-solid fa-bars" })
], -1)
const _hoisted_16 = { class: "p-ml-2" }
const _hoisted_17 = { class: "p-col-4" }
const _hoisted_18 = {
  key: 0,
  class: "kn-flex p-d-flex p-flex-column p-jc-between helpCol p-m-2"
}
const _hoisted_19 = { class: "p-float-label p-text-uppercase p-m-2" }
const _hoisted_20 = {
  key: 0,
  class: "helpClass"
}
const _hoisted_21 = {
  key: 1,
  class: "p-m-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_Card = _resolveComponent("Card")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary calculatedFieldDialogClass",
    visible: _ctx.visibility,
    header: _ctx.$t('components.knCalculatedField.title'),
    closable: false,
    modal: "",
    breakpoints: { '960px': '75vw', '640px': '100vw' }
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: _ctx.readOnly ? 'kn-button kn-button--primary' : 'kn-button kn-button--secondary',
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.cancel
      }, null, 8, ["class", "label", "onClick"]),
      (!_ctx.readOnly)
        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "kn-button kn-button--primary",
            onClick: _ctx.apply,
            disabled: _ctx.saveButtonDisabled
          }, null, 8, ["onClick", "disabled"])), [
            [_directive_t, 'common.apply']
          ])
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Message, {
        severity: "info",
        closable: false
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('components.knCalculatedField.description')), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              ref: "colName",
              type: "text",
              disabled: _ctx.readOnly,
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.cf.colName.$invalid
                        }],
              id: "colName",
              modelValue: _ctx.v$.cf.colName.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.cf.colName.$model = $event)),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.cf.colName.$touch()))
            }, null, 8, ["disabled", "modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('components.knCalculatedField.columnName')), 1)
          ])
        ]),
        _renderSlot(_ctx.$slots, "additionalInputs")
      ]),
      _createVNode(_component_Card, { class: "card-0-padding" }, {
        content: _withCtx(() => [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t('components.knCalculatedField.fields')), 1),
              _createVNode(_component_ScrollPanel, {
                class: "kn-list knListBox kn-flex kn-list-no-border-right",
                style: {"height":"200px !important","border":"1px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
                    return _withDirectives((_openBlock(), _createBlock("div", {
                      key: index,
                      class: "kn-list-item p-d-flex p-ai-center fieldType kn-truncated p-ml-2",
                      draggable: "true",
                      onDragstart: ($event: any) => (_ctx.dragElement($event, field, 'field'))
                    }, [
                      _hoisted_8,
                      (_ctx.source === 'QBE')
                        ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(field.fieldLabel), 1))
                        : (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(field.fieldAlias), 1))
                    ], 40, ["onDragstart"])), [
                      [
                        _directive_tooltip,
                        _ctx.source === 'QBE' ? field.fieldLabel : field.fieldAlias,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("span", _hoisted_12, [
                _createVNode(_component_Dropdown, {
                  id: "category",
                  modelValue: _ctx.selectedCategory,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedCategory = $event)),
                  options: _ctx.availableCategories,
                  class: "kn-material-input",
                  optionLabel: "name",
                  optionValue: "code",
                  onChange: _ctx.filterFunctions
                }, null, 8, ["modelValue", "options", "onChange"]),
                _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t(_ctx.descriptor.category.label)), 1)
              ]),
              _createVNode("h5", _hoisted_14, _toDisplayString(_ctx.$t('components.knCalculatedField.functions')), 1),
              _createVNode(_component_ScrollPanel, {
                class: "kn-list knListBox kn-flex kn-list-no-border-right",
                style: {"height":"150px !important","border":"1px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableFunctions, (af, index) => {
                    return _withDirectives((_openBlock(), _createBlock("div", {
                      key: index,
                      class: ["kn-list-item p-d-flex p-ai-center formulaType kn-truncated p-ml-2", { selected: af.formula === _ctx.selectedFunction.formula }],
                      draggable: "true",
                      onDragstart: ($event: any) => (_ctx.dragElement($event, af, 'function')),
                      onClick: ($event: any) => (_ctx.handleClick(af))
                    }, [
                      _hoisted_15,
                      _createVNode("div", _hoisted_16, _toDisplayString(af.formula), 1)
                    ], 42, ["onDragstart", "onClick"])), [
                      [
                        _directive_tooltip,
                        af.formula,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_17, [
              (_ctx.showHelpPanel)
                ? (_openBlock(), _createBlock("span", _hoisted_18, [
                    _createVNode("h5", _hoisted_19, _toDisplayString(_ctx.selectedFunction.label), 1),
                    _createVNode(_component_ScrollPanel, { class: "helpScrollPanel custombar1" }, {
                      default: _withCtx(() => [
                        _createVNode("div", {
                          innerHTML: _ctx.$t(_ctx.selectedFunction.help)
                        }, null, 8, ["innerHTML"])
                      ]),
                      _: 1
                    }),
                    (_ctx.selectedFunction.officialDocumentationLink)
                      ? (_openBlock(), _createBlock("div", _hoisted_20, [
                          _createVNode("a", {
                            href: _ctx.selectedFunction.officialDocumentationLink,
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t('components.knCalculatedField.officialDocumentation', { function: _ctx.selectedFunction.label })), 9, ["href"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_21, [
                    _createVNode(_component_KnHint, {
                      class: "kn-hint-sm",
                      title: 'components.knCalculatedField.title',
                      hint: _ctx.$t(_ctx.descriptor.hint),
                      "data-test": "hint"
                    }, null, 8, ["title", "hint"])
                  ]))
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_VCodeMirror, {
        class: ['p-mt-2 codeMirrorClass', this.readOnly ? 'readOnly' : '', _ctx.v$.cf.formula.$invalid ? 'p-invalid' : ''],
        ref: "formula",
        value: _ctx.cf.formula,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.cf.formula = $event)),
        options: _ctx.scriptOptions,
        onDrop: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drop($event))),
        onDragover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleDragover($event))),
        modelValue: _ctx.v$.cf.formula.$model,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.cf.formula.$model = $event))
      }, null, 8, ["class", "value", "options", "modelValue"])
    ]),
    _: 3
  }, 8, ["visible", "header"]))
}